import type {AsyncNamespace, NexusSignal, OttoNexus} from "@otto-ec/global-resources/nexus";
import type {EventMergeContext} from "@otto-ec/tracking-bct";
import type {FacetValueTagsLoadedData} from "./types/global";

declare global {
  interface NexusInterfaces {
    stomachshop: AsyncNamespace<{
      /*                                                                                               */
      onSearchFocus: NexusSignal<EventMergeContext>;
      /*                                                                                                                  */
      consentEnabled: NexusSignal<boolean>;
    }>;
    heureka: AsyncNamespace<{
      facetValueTags_loaded: NexusSignal<FacetValueTagsLoadedData>;
    }>;
  }
}
export type Stomachshop = OttoNexus["stomachshop"];
export const stomachshop: Stomachshop = otto.stomachshop;
export const onSearchFocus: Stomachshop["onSearchFocus"] = stomachshop.onSearchFocus;
export const consentEnabled: Stomachshop["consentEnabled"] = stomachshop.consentEnabled;